import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { IHowHoverWorksTab } from '../interfaces/IHowHoverWorksTab';

const HOW_HOVER_WORKS_LIST_DATA: IHowHoverWorksTab[] = [
  {
    title: 'TAKE SOME PHOTOS',
    body: 'With just a few photos, HOVER can create an accurately measured 3D model of a home.',
    id: 0,
    desktopImage: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        alt="take photo 1"
        src="../assets/images/how_does_hover_work_take_photo_1.png"
        objectFit="contain"
      />
    ),
    mobileImage: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        alt="take photo 1"
        src="../assets/images/how_does_hover_work_take_photo_1_mobile.png"
        objectFit="contain"
      />
    ),
  },
  {
    title: 'BETTER MEASUREMENTS',
    body: 'Your pro gets a detailed report of accurate measurements of your home from those photos.',
    id: 1,
    desktopImage: (
      <StaticImage
        quality={100}
        objectFit="contain"
        placeholder="blurred"
        alt="better measurements 1"
        src="../assets/images/how_does_hover_work_better_measurement.png"
      />
    ),
    mobileImage: (
      <StaticImage
        objectFit="contain"
        quality={100}
        placeholder="blurred"
        alt="better measurements 1"
        src="../assets/images/how_does_hover_work_better_measurement.png"
      />
    ),
  },
  {
    title: 'DREAM AND DESIGN',
    body: 'You get a 3D model of your home to design; with your pro, select materials for your project',
    id: 2,
    desktopImage: (
      <StaticImage
        quality={100}
        objectFit="contain"
        placeholder="blurred"
        alt="dream and design"
        src="../assets/images/how_does_hover_work_dream_design_1.png"
      />
    ),
    mobileImage: (
      <StaticImage
        objectFit="contain"
        quality={100}
        placeholder="blurred"
        alt="dream and design"
        src="../assets/images/how_does_hover_work_dream_design_1_mobile.png"
      />
    ),
  },
  {
    title: 'FAIR ESTIMATION',
    body: 'Your pro uses your design choices and measurements to quickly and accurately estimate your project.',
    id: 3,
    desktopImage: (
      <StaticImage
        quality={100}
        objectFit="contain"
        placeholder="blurred"
        alt="take photo"
        src="../assets/images/how_does_hover_work_fair_estimation.png"
      />
    ),
    mobileImage: (
      <StaticImage
        objectFit="contain"
        quality={100}
        placeholder="blurred"
        alt="take photo"
        src="../assets/images/how_does_hover_work_fair_estimation.png"
      />
    ),
  },
];

export default HOW_HOVER_WORKS_LIST_DATA;
